<h1 class="heading--huge">No results found for "{{ keyword }}"</h1>

<article>
	<h2 class="heading--3">Tips:</h2>
	<ul>
		<li>
			Try removing numbers and quantities eg: "milk
			<span class="text--strike">400ml</span>"
		</li>
		<li>
			Try fewer words, or partial words eg: "spag" is shorter than typing "spaghetti"
		</li>
	</ul>
</article>
<article>
	<h2 class="heading--3">Some common reasons for no search results:</h2>
	<ul class="suggestions">
		<li>
			<cdx-svg-icon name="temp-out-of-stock" fill="dark"></cdx-svg-icon>
			<p>An item is temporarily out of stock at your selected store.</p>
		</li>
		<li>
			<cdx-svg-icon name="item-changed" fill="dark"></cdx-svg-icon>
			<p>
				The item might have been changed by the manufacturer and the listing has not been updated yet.
			</p>
		</li>
		<li>
			<cdx-svg-icon name="perishable-items" fill="dark"></cdx-svg-icon>
			<p>
				Perishable items are not available for rural and provincial regions, so won't show in search results for these
				areas.
			</p>
		</li>
		<li>
			<cdx-svg-icon name="restricted-items" fill="dark"></cdx-svg-icon>
			<p>
				Some restricted items such as tobacco lines or alcohol will not show in the search results unless you are logged
				in and over 18 years old.
			</p>
		</li>
		<li>
			<cdx-svg-icon name="alert" fill="dark"></cdx-svg-icon>
			<p>
				We may be experiencing some issues with our search. Please try again, or contact us if the problem persists.
			</p>
		</li>
	</ul>
</article>
